export default "__VITE_ASSET__DGnhqzTQ__"